import LangEnum from '../../../lang/LangEnum';
import {
  CalculateOrderBookCardDataParams,
  OrderBookOrder,
} from '../../../stores/OrderBook/orderBook.types';
import { CustomerOptions } from '../../customer/types/customer.types';
import { Order } from '../../orders/order.types';

export const formatOrderInOrderBookOrder = (order: Order | OrderBookOrder): OrderBookOrder => ({
  brand: { id: order?.brand?.id },
  id: order.id,
  code: order.code,
  status: order.status,
  subTotal: order.subTotal,
  totalItems: order.totalItems,
  totalPieces: order.totalPieces,
  totalDiscountValue: order.totalDiscountValue,
  totalRetail: order.totalRetail,
  totalValue: order.totalValue,
  type: order.type,
  customer: {
    id: order?.customer?.id,
    code: order?.customer?.code,
    commercialName: order?.customer?.commercialName,
    companyName: order?.customer?.companyName,
    cpfcnpj: order?.customer?.cpfcnpj,
  },
  consultant: {
    id: order.consultant?.id,
  },
  priceTable: {
    id: order.priceTable?.id,
  },
  salesRepresentative: {
    id: order.salesRepresentative?.id,
  },
  seller: {
    id: order.seller?.id,
    userId: order.seller?.userId,
  },
});

const joinCityState = (city?: string, state?: string) =>
  city && state ? `${city} - ${state}` : (city ?? state ?? '');

export const buildPlace = (customer?: CustomerOptions): string => {
  if (!customer) {
    return '';
  }

  if ('addresses' in customer) {
    const main = customer.addresses?.find((a) => a.principal) ?? customer.addresses?.[0];
    return joinCityState(main?.address?.city, main?.address?.state);
  }

  if ('city' in customer || 'state' in customer) {
    return joinCityState(customer.city, customer.state);
  }

  return '';
};

export const getOrderCardSummary = ({
  order,
  isSelectedOrder,
  selectedOrder,
  selectedOrderSummary,
  orderProductsIds,
  orderProductsInfo,
  translate,
  locale,
}: CalculateOrderBookCardDataParams) => {
  const totalItems = isSelectedOrder
    ? orderProductsIds.productColorIds.length
    : (orderProductsInfo?.orderProductsIds?.productColorIds.length ?? order?.totalItems ?? 0);

  const totalPieces = isSelectedOrder
    ? (selectedOrderSummary?.pieces ?? selectedOrder?.totalPieces ?? 0)
    : (order?.totalPieces ?? 0);
  const formattedPieces = Intl.NumberFormat(locale).format(totalPieces);
  const formattedPiecesLabel = `${formattedPieces} ${totalPieces === 1 ? translate(LangEnum.GLOBAL_PIECE_SINGLE) : translate(LangEnum.GLOBAL_PIECES)}`;

  const totalValue = isSelectedOrder
    ? (selectedOrderSummary?.subtotal ?? 0)
    : (order?.subTotal ?? 0);

  return {
    items: {
      value: totalItems,
      formattedValue: translate(LangEnum.GLOBAL_ITEM, { quantity: totalItems }),
    },
    pieces: {
      value: totalPieces,
      label: formattedPiecesLabel,
      formattedValue: formattedPieces,
    },
    totalValue,
  };
};
